export const InspectionsListPage = () => {
  return (
    <section>
      <h2>Inspektionsaufträge</h2>
      <p style={{ marginTop: '12px', color: '#3b4b66' }}>
        Deine kommenden Einsätze werden hier mit Status und Ort angezeigt.
      </p>
    </section>
  );
};
